import React from 'react'
import Header from '../Components/Header/Header'
import ProductDetails from '../Components/ProductDetails/ProductDetails'

function ViewProductDetails() {
  return (
    <div>
        <Header></Header>
        <ProductDetails></ProductDetails>
    </div>
  )
}

export default ViewProductDetails